/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = ['$scope', 'Booking', 'downloadService'];

const PopupBookingUploadResultController = function($scope, Booking, downloadService) {

  const vm = this;

  const ERROR_WRONG_COLUMNS_COUNT = 1;

  vm.downloadFailFile = function () {
    downloadService.downloadBase64File(vm.importResult.fail_file);
  };

  vm.getSuccessText = function () {
    if (vm.importResult.success_count === 1) {
      return '1 booking and shift was uploaded';
    } else {
      return `${vm.importResult.success_count} bookings and shifts were uploaded`;
    }
  };

  vm.getFailText = function () {
    if (vm.importResult.fail_count === 1) {
      return '1 shift has problems';
    } else {
      return `${vm.importResult.fail_count} shifts have problems`;
    }
  };

  vm.hasWrongColumnCountError = function () {
    return vm.importResult.error === ERROR_WRONG_COLUMNS_COUNT;
  };

  vm.getDownloadTemplateUrl = function() {
    return Booking.importTemplateUrl();
  };

  const onPopupClose = function() {
    if (vm.importResult.success_count) {
      reloadPage();
    }
  };

  const reloadPage = function() {
    window.location.reload();
  };

  $scope.$on('popup.open', function() {
    if ($scope.popupShowCondition) {
      vm.importResult = $scope.importResult;
    }
  });

  $scope.$on('popup.close', onPopupClose);

  return vm;
};

angular.module('popup.booking')
  .controller('PopupBookingUploadResultController', dependencies.concat(PopupBookingUploadResultController));
